export const toursByYear = {
  2026: [
    {
      title: 'Concert - April 23 - Bologna (IT)',
      markdown: `I saw my lady weep w/ Clara La Licata (voice). Bar Modo Infoshop`,
    },
    {
      title: 'Concert - March 12 - Bologna (IT)',
      markdown: `[998. AngelicA Centro di Ricerca Musicale, Teatro San Leonardo](https://aaa-angelica.com/aaa/ricercaerinascimento/2025-2026-dodicesimo-anno/seconda-parte/)`,
    },
    {
      title: 'Concert - February 04 - Ghent (BE)',
      markdown: `998 / Floating Impros. Le Mercredis Libres, Hot Club`,
    },
    {
      title: 'Workshop - January 31 - Brussels (BE)',
      markdown: `[Multisensory Sounds. La Semaine du Son.Oor, Musée des Instruments de Musique (Salle De Concert)](https://www.lasemaineduson.be/event/multisensory-sounds/)`,
    },
  ],

  2025: [
    {
      title: 'Performance - June 22 - Bologna (IT)',
      markdown: `[Together, drifting w/ Daniel Cantero (dancer). No Glucose ‘Volo Vivace’, Le Serre d’Estate 2025, Le Serre dei Giardini Margherita](https://www.noglucosecollective.com/artista/melchionda-cantero/?evento_id=1450)`,
    },
    {
      title: 'Performance - June 20 - Firenze, Scandicci (IT)',
      markdown: `[Together, drifting w/ Daniel Cantero (dancer). Festival Nutida | Nuovə Danzatorə, Castello dell'Acciaiolo](https://www.stazioneutopia.com/nutida)`,
    },
    {
      title: 'Residency - June 12-19 - Bologna (IT)',
      markdown: `Together, drifting w/ Daniel Cantero (dancer). Leggere Strutture Art Factory`,
    },
    {
      title: 'Residency & Concert - April 30-May 02 - Sasso Marconi (IT)',
      markdown: `[Beatitudine on Organo Motore Acusmonium. Sleeping concert, CLOSER, Villa Davia Bargellini - Borgo di Colle Ameno](https://www.borgodicolleameno.it/portfolio/closer/)`,
    },
    {
      title: 'Concert - April 27 - Pisa (IT)',
      markdown: `[w/ Fonte Rossa Orchestra cond. by Mauro Avanzini, Silvia Bolognesi, Domenico Caliri, Emanuele Parrini, Chris Jonas. Fonte Rossa Days #9, Teatro Sant’Andrea](https://fb.me/e/37VURNqv3)`,
    },
    {
      title: 'Residency - February-April - Pisa (IT)',
      markdown: `w/ Fonte Rossa Orchestra cond. by Mauro Avanzini, Silvia Bolognesi, Domenico Caliri, Emanuele Parrini, Chris Jonas. ExWide`,
    },
    {
      title: 'Concert - March 18 - Bologna (IT)',
      markdown: `[I saw my lady weep w/ Clara La Licata (voice). Teatro Giù dall’Arca](https://teatrinindipendenti.it/giu-dallarca/eventipassati/i-saw-my-lady-weep)`,
    },
    {
      title: 'Concert - March 13 - Bologna (IT)',
      markdown: `[w/ Alberto Anhaus (live electronics). Bar Modo Infoshop](https://fb.me/e/97ATcafz5)`,
    },
  ],

  2024: [
    {
      title: 'Concert - August 31 - Bologna (IT)',
      markdown: `[I saw my lady weep w/ Clara La Licata. Frida nel Parco](https://fb.me/e/46M5UsqV3)`,
    },
    {
      title: 'Concert - June 29 - Torino (IT)',
      markdown: `[#998. JS Bach On Psychedelic. Quois Festival, PAV Parco Arte Vivente](https://parcoartevivente.it/quois-festival/)`,
    },
    {
      title: 'Concert - June 07 - Bologna (IT)',
      markdown: `[I saw my lady weep w/ Clara La Licata. Circolo HEX](https://fb.me/e/47OWSlzMC)`,
    },
    {
      title: 'Concert - May 12 - Bologna (IT)',
      markdown: `[w/ Andrea Calì and Lalla Laura Cracolici. Discomfort Dispatch #51 - Call for Ceasefire - Benefit for Gaza, Circolo DEV](https://fb.me/e/4p5ZtuFs6)`,
    },
    {
      title: 'Concert - May 07 - Bologna (IT)',
      markdown: `All’amico carissimo Federico Salce (G. Cappelli) w/ 40 guitars ensemble. España En El Corazón, Exitime 2024 Festival FontanaMix Ensemble, Ex Chiesa Di San Mattia`,
    },
    {
      title: 'Performance - April 17 - Bologna (IT)',
      markdown: `[Forget-me-not (dance and music performance) composed by and performed with Michele Scappa (dancer), Lucas Delfino (dancer), Sandro Manzon (music composition and conduction). Crudo Festival, Teatro Dehon](https://www.crudofestival.com/17-aprile/?fbclid=IwZXh0bgNhZW0CMTEAAR19nNcubrazEEysY22gCsvPybNghR6cVXDYMPdj1prJZjyqfanyW_Q_VOg_aem_Afn5JiRr7eIlJ4tGGsYrcXAVyeVCqdr4amEvnnYbHhcu7RpbpDItyhvqTnlqUmDcQwe2812E__Y-XbB6qH7SY6LF)`,
    },
    {
      title: 'Concert - March 28 - Bologna (IT)',
      markdown: `[#998. JS Bach On Psychedelics, Bar Modo Infoshop](https://fb.me/e/4gDrsWbPw)`,
    },
    {
      title: 'Concert - March 20 - Brussels (BE)',
      markdown: `[#998. JS Bach On Psychedelics. SMOG n. 102](http://www.smogmusic.org/agenda/smog102/)`,
    },
    {
      title: 'Concert - February 28 - Bologna (IT)',
      markdown: `[I saw my lady weep w/ Clara La Licata. Cemento](https://www.facebook.com/CementoBologna/photos/i-saw-my-lady-weep-live-mercoledi-28-febbraio/336034022767206/?_rdr)`,
    },
    {
      title: 'Concert - January 22 - Brussels (BE)',
      markdown: `[w/ Ictus Ensemble, Sound & Body. Bozar Centre for Fine Arts](https://www.bozar.be/en/calendar/sound-body-ictus)`,
    },
    {
      title: 'Concert - January 21 - Brussels (BE)',
      markdown: `[w/ Ictus Ensemble, Sound & Body. Bozar Centre for Fine Arts](https://www.bozar.be/en/calendar/sound-body-ictus)`,
    },
    {
      title: 'Concert - January 13 - Bologna (IT)',
      markdown: `[Bologna for Palestine (benefit concert with various musicians). DAS](https://fb.me/e/7fYIonbac)`,
    },
  ],

  2023: [
    {
      title: 'Concert - December 15 - Bagnacavallo (IT)',
      markdown: `[Changes w/ Soniche 2023. Magma](https://www.magma.zone/ssiege-soniche-2023-plays-changes-by-ellen-arkbro)`,
    },
    {
      title: 'Concert - December 14 - Torino (IT)',
      markdown: `[Changes w/ Soniche 2023. Almare](https://circolodeldesign.it/evento/soniche-2023-plays-changes-di-ellen-arkbro/)`,
    },
    {
      title: 'Concert - December 07 - Brescia (IT)',
      markdown: `[Changes w/ Soniche 2023. Spettro](https://fb.me/e/5xuVwYuJu)`,
    },
    {
      title: 'Concert - December 02 - Pistoia (IT)',
      markdown: `[Changes w/ Soniche 2023. Nub](https://www.nubprojectspace.com/programma/soniche-2023-plays-changes-by-ellen-arkbro.shtml)`,
    },
    {
      title: 'Concert - December 01 - Bologna (IT)',
      markdown: `[Changes w/ Soniche 2023. DAS](https://www.dasbologna.org/evento/collagene-3-m-c-pederzini-c-ferronato-c-dalmazio-soniche-2023/)`,
    },
    {
      title: 'Residency & Concert - November 08-12 - Modena (IT)',
      markdown: `[Changes w/ Ellen Arkbro - Soniche 2023.](https://musicommission.emiliaromagnacultura.it/news/soniche-2023-plays-changes-by-ellen-arkbro/) [La Torre - 71MusicHub](https://musicommission.emiliaromagnacultura.it/news/soniche-2023-plays-changes-by-ellen-arkbro/)`,
    },
    {
      title: 'Residency & Concert - October 27-29 - Rome (IT)',
      markdown: `[w/ Alvin Curran, Giancarlo Schiaffini, Eddie Prévost and others, Workshop on creative improvisation and instant composition: 1960 - 2023. Accademia Filarmonica Romana](https://www.facebook.com/photo/?fbid=296578836664198&set=a.117413881247362)`,
    },
    {
      title: 'Performance - September 27 - Ghent (BE)',
      markdown: `[Bouffe, Live sonorisation of Family Dinner w/ Bouffe. Nomadic School of Arts, Cirque Anatomisch Auditorium, Royal Conservatory & KASK](https://fb.me/e/5WvdH19Dj)`,
    },
    {
      title: 'Concert - August 16 - Darmstadt (DE)',
      markdown: `[#998. JS Bach On Psychedelics. DARMSTÄDTER FERIENKURSE](https://www.instagram.com/p/Cv_sywXIKeb/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==)`,
    },
    {
      title: 'Residency & Concert - August 09-15 - Darmstadt (DE)',
      markdown: `[Creative Orchestra conducted by Anthony Braxton, Kobe van Cauwenberghe, Katherine Young. DARMSTÄDTER FERIENKURSE](https://www.facebook.com/photo?fbid=10231272151936672&set=pcb.10231272154536737)`,
    },
    {
      title: 'Concert - June 27 - Ghent (BE)',
      markdown: `[Postcontemporary Baroque - #998 (solo) and Non Mesurés w/ Lieve De Sadeleer, Miry Conzertzaal](https://fb.me/e/XGYkS4TJ)`,
    },
    {
      title: 'Performance - May 04 - Ghent (BE)',
      markdown: `[w/ Lyra Oey (visual artist/perfomer), De Kotroute, GUM Gents Universiteitsmuseum](https://fb.me/e/8EiRb3tHZ)`,
    },
    {
      title: 'Performance - May 04 - Ghent (BE)',
      markdown: `[Together, drifting w/ Daniel Cantero (dancer). De Kotroute, GUM Gents Universiteitsmuseum](https://fb.me/e/8EiRb3tHZ)`,
    },
    {
      title: 'Residency & Concert - March 20-24 - Brussels (BE)',
      markdown: `[w/ Antonio La Spina, Maurizio Tedde - GAME. S M O G n83, SMOG - première](http://www.smogmusic.org/agenda/24th-march-2023/)`,
    },
    {
      title: 'Residency & Concert - February 19-23 - Ghent (BE)',
      markdown: `[w/ Diamanda La Berge Dramm - GAME, Hedendaagse kruisbestuiving. Miry Conzertzaal](https://miryconcertzaal.be/game-diamanda-dramm/)`,
    },
    {
      title: 'Performance - January 21 - Brussels (BE)',
      markdown: `[w/ Ictus Ensemble, Sound & Body. Bozar Centre for Fine Arts](https://www.bozar.be/en/calendar/ictus-6)`,
    },
    {
      title: 'Performance - January 20 - Brussels (BE)',
      markdown: `[w/ Ictus Ensemble, Sound & Body. Bozar Centre for Fine Arts](https://www.bozar.be/en/calendar/soundbody)`,
    },
  ],

  2022: [
    {
      title: 'Residency & Concert - December 10-15 - Ghent (BE)',
      markdown: `[w/ Jessie Cox - GAME, Onbetreden paden. Miry Conzertzaal](https://miryconcertzaal.be/game-jessie-cox/)`,
    },
    {
      title: 'Concert - December 03 - Ghent (BE)',
      markdown: `[w/ Lieve de Sadeleer. Ear to the Ground #4, Muziekcentrum De Bijloke](https://www.bijloke.be/programma/2586/_strong_Wie_strong_Ghent_Advanced_Master_Ensemble_br_strong_Wat_strong_Dubbeldate_in_de_Foyer/GAME?fbclid=IwAR2FO7J3fI-nv68XH7MtECT8mW-zMEGVgns6QdBooj-KNUIutqQUGqH7nAM)`,
    },
    {
      title: 'Performance - November 18 - Hasselt (BE)',
      markdown: `[BEATITUDINE. Performance Night, De Nieuwe Zaal - première](https://www.ccha.be/programma/4150/Leonardo_Melchionda/BEATITUDINE)`,
    },
    {
      title: 'Residency - February-November - Hasselt (BE)',
      markdown: `BEATITUDINE. Studio Classic, B-Classic, Vonk Ateliers`,
    },
    {
      title: 'Performance - October 29 - Ghent (BE)',
      markdown: `[w/ De Vloer (dance company), MOVBOD22BIG. BROEI doe- en denkplek](https://fb.me/e/2Wrx3b3j9)`,
    },
    {
      title: 'Performance - October 28 - Ghent (BE)',
      markdown: `[w/ De Vloer (dance company), MOVBOD22BIG. BROEI doe- en denkplek - première](https://fb.me/e/2gzrSoHwX)`,
    },
    {
      title: 'Performance - October 26 - Ghent (BE)',
      markdown: `[Shattered Whispers, Echoes of Sandstorms w/ Lyra Oey (visual artist/perfomer). SLOTEXPO BROEI 2022, BROEI doe- en denkplek](https://fb.me/e/21dVzoPLs)`,
    },
    {
      title: 'Performance - October 20 - Ghent (BE)',
      markdown: `[Shattered Whispers, Echoes of Sandstorms w/ Lyra Oey (visual artist/perfomer). BLIKKENWERPERS EXPO Gent, BROEI doe- en denkplek - première/site specific](https://fb.me/e/2Umlg8ZS7)`,
    },
    {
      title: 'Residency - September-October - Ghent (BE)',
      markdown: `Shattered Whispers, Echoes of Sandstorms w/ Lyra Oey (visual artist/perfomer). BLIKKENWERPERS EXPO Gent, BROEI doe- en denkplek`,
    },
    {
      title: 'Residency & Performance - August 20-31 - Ghent (BE)',
      markdown: `Beatitudine. Bijloke Summer Academy 2022, LOD Muziektheater`,
    },
    {
      title: 'Performance - July 01 - Brussels (BE)',
      markdown: `[Together, drifting w/ Daniel Cantero (dancer). Exiiit Festival, P.A.R.T.S. - Rosas - première](https://www.parts.be/news/together-drifting?fbclid=IwAR1vh-b7gZEc9GfcVgXhb7D4lvBvqQcYQIm6-SykvSf0043tuyjjGoHmnb8)`,
    },
    {
      title: 'Concert - May 28 - Brussels (BE)',
      markdown: `[w/ GAME, classical guitar and performance, Souffle. Ictus Studio](https://fb.me/e/39zrK1OrU)`,
    },
    {
      title: 'Concert - May 25 - Ghent (BE)',
      markdown: `[w/ Anita Cappuccinelli. New Hyperion Ensemble @ Hot Club Gent, Le Mercredis Libres, Hot Club](https://fb.me/e/3nfMBssow)`,
    },
    {
      title: 'Residency & Performance - March 16-19 - Mechelen (BE)',
      markdown: `[w/ Fritz Hauser - Ictus Ensemble, La Flèche et l’Éléphant, Europalia Arts Festival, Mechelen Central Workshop](https://www.ictus.be/fleche)`,
    },
    {
      title: 'Concert - March 09 - Ghent (BE)',
      markdown: `w/ Bart Maris. Le Mercredis Libres, Hot Club`,
    },
    {
      title: 'Performance - March 06 - Ghent (BE)',
      markdown: `[w/ Bart Maris, live soundtrack for Twee ambachten, (meer dan) dertien (grappige) ongelukken (8+) — The Pawnshop (Charles Chaplin, 1916) & The Electric House (Buster Keaton & Eddie Cline, 1922). Classic Restored Festival 2022, KASKcinema](https://www.kaskcinema.be/kaskcinema/vertoning/classics_restored_festival1)`,
    },
    {
      title: 'Concert - February 25 - Brussels (BE)',
      markdown: `[Solo recital classical and electric guitar. Klarafestival BOX, De Brouckèreplein](https://klarafestival.brussels/en/concert/09-03-2022/klarafestival-box)`,
    },
    {
      title: 'Performance - February 03 - Kortrijk (BE)',
      markdown: `[BEATITUDINE (live streaming). Exhibition De windstoot of Marianne Schipaanboord, Have we anything in Common?, vzw Wit.h](https://www.vzwwith.org/nl/beatitudine-voor-marianne-schipaanboord/)`,
    },
    {
      title: 'Residency & Performance - February 01-05 - Bruges (BE)',
      markdown: `[w/ Joris Blanckaert - GAME, Bergensbanen - RE:Treat. Slow (36h) Festival, Concertgebouw - première/site specific](https://www.concertgebouw.be/en/bergensbanen)`,
    },
    {
      title: 'Concert - January 19 - Ghent (BE)',
      markdown: `w/ Bart Maris - Giovanni Barcella. Le Mercredis Libres, Hot Club`,
    },
  ],

  2021: [
    {
      title: 'Concert - December 20-23 - Ghent (BE)',
      markdown: `[w/ Marlies Debacker - GAME. Miry Conzertzaal](https://miryconcertzaal.be/game-marlies-debacker/)`,
    },
    {
      title: 'Concert - November 21 - Brussels (BE)',
      markdown: `[w/ Andrea Mancianti - Federico Tramontana. Bozar Next Generation, Bozar Centre for Fine Arts](https://www.bozar.be/en/calendar/bozar-next-generation-andrea-mancianti-leonardo-melchionda-federico-tramontana)`,
    },
    {
      title: 'Residency & Concert - November 09-13 - Brussels (BE)',
      markdown: `[w/ GAME. S M O G n55, SMOG](http://www.smogmusic.org/agenda/smog55/)`,
    },
    {
      title: 'Concert - September 16 - Bologna (IT)',
      markdown: `[#998 / Rings & Buffalo Jam. Circolo DEV](https://fb.me/e/1uhRcCUr0)`,
    },
    {
      title: 'Concert - July 06 - Bologna (IT)',
      markdown: `[#998 / Rings & Buffalo Jam. L’APPARTAMENTO di Maison Ventidue](http://www.maisonventidue.it/leonardo-melchionda-live/?fbclid=IwAR0QGuHuHe9_VJ5Kd6YVYw4cSn9WGE45Sm8c8KEYgeph3lgWqhtaef59KLw)`,
    },
    {
      title: 'Concert - June 30 - Ghent (BE)',
      markdown: `mandolin, w/ Franches Dhont - Gent Conservatorium Ensemble, Mysteries of the Macabre (G. Ligeti) in Phosphenes, Filip Rathé (conductor), Laura De Moor (stage director). Graduation 2021 - Afstudeerfestival KASK & Conservatorium, Miry Conzertzaal`,
    },
    {
      title: 'Performance - June 27 - Ghent (BE)',
      markdown: `Mixed Motions w/ Lyra Oey - Ellen Preuss. The Flying Carrot`,
    },
    {
      title: 'Concert - June 26 - Ghent (BE)',
      markdown: `[w/ GAME, Listen to the Lamb!. Gent Festival van Vlaanderen, Kunstencentrum Vooruit](https://fb.me/e/1uIXlRCir)`,
    },
    {
      title: 'Residency & Concert - May 01-05 - Ghent (BE)',
      markdown: `[w/ Fritz Hauser - GAME, Schraffur (F. Hauser). Miry Conzertzaal](https://miryconcertzaal.be/fritz-hauser-game-schraffur/?fbclid=IwAR1L1w4k6w2l0nYlq7-83wiBDqKtRWFc4EuVbwrcOedTYiMla6KkOSgaC1k)`,
    },
    {
      title: 'Concert - April 24 - Ghent (BE)',
      markdown: `w/ New Hyperion Ensemble. Gentse Raamconcerten`,
    },
    {
      title: 'Residency & Concert - March 03-06 - Brussels (BE)',
      markdown: `[w/ Kobe van Cauwenberghe (conduction) - Ictus Ensemble , Anthony Braxton Ghost Trance Music. Ictus Invites #2, Wild Gallery](https://www.ictus.be/gtm)`,
    },
  ],

  2020: [
    {
      title: 'Concert - September 29-October 03 - Ghent (BE)',
      markdown: `[w/ GAME, Listen to the Lamb!. Gent Festival van Vlaanderen, Muziekcentrum De Bijloke - première](https://fb.me/e/cdRyAH1Zs)`,
    },
    {
      title: 'Concert - March 08 - Ghent (BE)',
      markdown: `[w/ Bart Maris - Iryna Grytsiv, live soundtrack for Het verhaal van de zwerver — Charlie Chaplin kortfilms (1914-1917). Classic Restored Festival 2020, KASKcinema](https://cinea.be/events/classics-restored-festival-2020/)`,
    },
  ],

  2019: [
    {
      title: 'Concert - June 20 - Bologna (IT)',
      markdown: `[w/ New Hyperion Ensemble, Bar Modo Infoshop](https://fb.me/e/ZwK1Yn6T)`,
    },
    {
      title: 'Residency & Concert - May 12-16 - Bologna (IT)',
      markdown: `[w/ Giorgio Magnanensi (conduction/composition) - INCROCIorchestra, Teatro dell’Udito. AngelicA29 Festival Internazionale di Musica, Teatro San Leonardo](https://www.aaa-angelica.com/aaa/festival/angelica-29-giorgio-magnanensi-incrociorchestra-tdu-xlab/?fbclid=IwAR1Mgy0xaqNVK-C5qJJ8NRKbJhYYpBAHkp5SysUXGVlK9yc3nZ9KKEYOE54)`,
    },
    {
      title: 'Concert - May 11 - Bologna (IT)',
      markdown: `[w/ New Hyperion Ensemble, Bologna Elettrica, XM24](https://fb.me/e/1dd3shtD4)`,
    },
    {
      title: 'Concert - February 16 - Bologna (IT)',
      markdown: `[w/ New Hyperion Ensemble. Ikigai Room](https://fb.me/e/459a0p4OV)`,
    },
  ],

  2018: [
    {
      title: 'Concert - December 05 - Bologna (IT)',
      markdown: `[w/ INCROCIorchestra, STEP TWO cartolina per Alvin e tutto il resto. AngelicA Centro di Ricerca Musicale, Teatro San Leonardo](https://www.aaa-angelica.com/aaa/ricercaerinascimento/2018-2019-quinto-anno/ottobre-novembre-dicembre-2018/incrocilab-step-two/)`,
    },
    {
      title: 'Concert - July 06 - Bologna (IT)',
      markdown: `[w/ New Hyperion Ensemble. Mikasa](https://fb.me/e/S5IIrIhN)`,
    },
    {
      title: 'Concert - May 27 - Bologna (IT)',
      markdown: `[w/ New Hyperion Ensemble. Ipermusiche, Fondazza soundsystem](https://fb.me/e/2Zv7tiKCo)`,
    },
    {
      title: 'Residency & Concert - May 09-12 - Bologna (IT)',
      markdown: `[w/ Alvin Curran (conduction/composition) - INCROCIorchestra, A Banda Larga. AngelicA28 Festival Internazionale di Musica, Basilica Santa Maria dei Servi](https://www.aaa-angelica.com/aaa/festival/angelica-28-alvin-curran-banda-larga-sinfonia-strada-stati-uniti-italia/?fbclid=IwAR379vQeJLBw0sZOyx7PswCfDPmph2oy47GiLb3uNgsqJPQmRpJqnmd1MtY)`,
    },
    {
      title: 'Concert - May 05 - Bologna (IT)',
      markdown: `[w/ New Hyperion Ensemble, POSTPOSTPOST #2, Mikasa](https://fb.me/e/2xweuCBLr)`,
    },
  ],

  2017: [
    {
      title: 'Concert - October 13 - Rimini (IT)',
      markdown: `[zeroZero. Upside Down II Edition, Centro giovani Casa Pomposa](https://fb.me/e/11UNInyIf)`,
    },
    {
      title: 'Concert - July 04 - Bologna (IT)',
      markdown: `[zeroZero. Brick telling, Telling Stories APS](https://fb.me/e/QCStBfd6)`,
    },
    {
      title: 'Concert - May 27 - Bologna (IT)',
      markdown: `[zeroZero. Bologna elettrica, XM24](https://www.facebook.com/events/1976256319275504)`,
    },
    {
      title: 'Concert - April 05 - Bologna (IT)',
      markdown: `[zeroZero. Poverarte_17 - Festival Di Tutte Le Arti 2 ½, ateliersi](https://fb.me/e/FInQPHDT)`,
    },
    {
      title: 'Concert - March 16 - Bologna (IT)',
      markdown: `[w/ Filippo Giuffrè. Discomfort Dispatch #1 - Free Impro Festival, secret location](https://fb.me/e/150w5qMG9)`,
    },
    {
      title: 'Concert - February 11 - San Giovanni Rotondo (IT)',
      markdown: `[zeroZero. Provo Cult Clab](https://fb.me/e/1hdovlN3r)`,
    },
    {
      title: 'Concert - January 07 - Bologna (IT)',
      markdown: `[zeroZero. Solitaire at Dynamo, Velostazione Dynamo](https://fb.me/e/1D1y5N8qg)`,
    },
  ],

  2016: [
    {
      title: 'Concert - December 10 - Bologna (IT)',
      markdown: `[zeroZero. NE555, LOFT Kinodromo](https://fb.me/e/3HJ3m4C5a)`,
    },
    {
      title: 'Concert - October 01 - Bologna (IT)',
      markdown: `[zeroZero. FOG, LOFT Kinodromo](https://fb.me/e/10l1qDg1G)`,
    },
    {
      title: 'Performance - September 05 - Bologna (IT)',
      markdown: `[w/ zerocrediti, ADDIO ROMA, Bernardo Lo Sterzo (conductor), Eleonora Gronchi (stage director). Giardino Zu.Art](https://fb.me/e/ljSCPfnNj)`,
    },
    {
      title: 'Concert - June 09 - Bologna (IT)',
      markdown: `w/ INCROCIorchestra, Conductions e chimiche acustiche. Chiostro del Conservatorio "G.B. Martini"`,
    },
  ],
};
